import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import dynamic from 'next/dynamic';
import App from '@/components/App/App';
import Spinner from '@/components/common/Spinner';
import { useLocalStorage } from '@/src/hooks/useLocalStorage';

const DownloadForm = dynamic(() => import('../../components/common/DownloadForm'));
const Slider = dynamic(() => import('../../components/Main/Slider'));
const MultiCoverage = dynamic(() => import('../../components/Main/MultiCoverage'));
const Connections = dynamic(() => import('../../components/Main/Connections'));
const Welcome = dynamic(() => import('../../components/Main/Welcome'));

const Main = () => {
  const { get } = useLocalStorage();
  const isLoading = get('isLodaing');
  return (
    <div className="mainwrapTerminal">
      <App>
        <div className="content index-content">
          {isLoading ? (
            <Spinner />
          ) : (
            <>
              <Welcome />
              <Slider />
              <MultiCoverage />
              <Connections />
              <DownloadForm inputId="3530" btnId="6947" />
            </>
          )}
        </div>
      </App>
    </div>
  );
};

export const getStaticProps = async ({ locale }) => ({
  props: {
    ...(await serverSideTranslations(locale, ['common'])),
  },
  revalidate: 60 * 60,
});

export default Main;
